export const wms_logistics = {
    id: "MENU_WMS_LOGISTICS",
    icon: "InfoIcon",
    text: "Kho vận",
    child: [
      {
        id: "MENU_WMS_LOGISTICS.SALES_ORDER",
        path: "/wms/logistics/salesorders",
        isPublic: true,
        text: "Đơn hàng bán",
        child: [],
      },
      {
        id: "MENU_WMS_LOGISTICS.PURCHASE_ORDER",
        path: "/wms/logistics/purchaseorders",
        isPublic: true,
        text: "Đơn hàng mua",
        child: [],
      },
      {
        id: "MENU_WMS_LOGISTICS.SALES_SHIPMENT",
        path: "/wms/logistics/saleshipment",
        isPublic: true,
        text: "Phiếu xuất",
        child: [],
      },
      {
        id: "MENU_WMS_LOGISTICS.PURCHASE_SHIPMENT",
        path: "/wms/logistics/purchaseshipment",
        isPublic: true,
        text: "Phiếu nhập",
        child: [],
      },
      {
        id: "MENU_WMS_LOGISTICS.DELIVERY_BILL",
        path: "/wms/logistics/deliverybill",
        isPublic: true,
        text: "Phiếu giao hàng",
        child: [],
      },
      {
        id: "MENU_WMS_LOGISTICS.DELIVERY",
        path: "/wms/logistics/delivery",
        isPublic: true,
        text: "Đợt giao hàng",
        child: [],
      },
      {
        id: "MENU_WMS_LOGISTICS.DELIVERY_ROUTE",
        path: "/wms/logistics/deliveryroute",
        isPublic: true,
        text: "Chuyến giao hàng",
        child: [],
      },
      {
        id: "MENU_WMS_LOGISTICS.VEHICLE",
        path: "/wms/logistics/vehicle",
        isPublic: true,
        text: "QL đội xe",
        child: [],
      },
      {
        id: "MENU_WMS_LOGISTICS.SHIPPER",
        path: "/wms/logistics/shipper",
        isPublic: true,
        text: "QL nhân viên giao hàng",
        child: [],
      },
      
      {
        id: "MENU_WMS_LOGISTICS.DASHBOARD",
        path: "/wms/logistics/dashboard",
        isPublic: true,
        text: "Dashboard",
        child: [],
      }
    ],
  };
  